import { Box } from "@mui/material"
import React from "react"
import { useDeviceAV } from "../../app/hooks/useDeviceAV"
import { UserVideo } from "../UserVideo/UserVideo"
import { DeviceSelectionDialog } from "./DeviceSelectionDialog"
import { MediaControlsBar } from "./MediaControlsBar"

export function MediaSetupControls() {
  const {
    audioInputs,
    videoInputs,
    isMicEnabled,
    isCameraEnabled,
    settingsOpen,
    selectedAudioInput,
    selectedVideoInput,
    handleAudioInputChange,
    handleVideoInputChange,
    handleSettingsClick,
    handleSettingsClose,
    toggleMicrophone,
    toggleCamera,
  } = useDeviceAV()

  return (
    <React.Fragment>
      <Box
        sx={{
          position: "absolute",
          left: "var(--spacing-tokens-size-in-px-spacing-spacing-2xl)",
          bottom: {
            xs: "var(--spacing-tokens-size-in-px-spacing-spacing-9xl)",
            sm: "var(--spacing-tokens-size-in-px-spacing-spacing-2xl)",
          },
        }}
      >
        <UserVideo />
      </Box>

      <MediaControlsBar
        isMicEnabled={isMicEnabled}
        isCameraEnabled={isCameraEnabled}
        toggleMicrophone={toggleMicrophone}
        toggleCamera={toggleCamera}
        onSettingsClick={handleSettingsClick}
        bottom="var(--spacing-tokens-size-in-px-spacing-spacing-2xl)"
      />

      <DeviceSelectionDialog
        open={settingsOpen}
        onClose={handleSettingsClose}
        audioInputs={audioInputs}
        videoInputs={videoInputs}
        selectedAudioInput={selectedAudioInput}
        selectedVideoInput={selectedVideoInput}
        handleAudioInputChange={handleAudioInputChange}
        handleVideoInputChange={handleVideoInputChange}
      />
    </React.Fragment>
  )
}
